var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDinersClub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H30C31.933 0.5 33.5 2.067 33.5 4V20C33.5 21.933 31.933 23.5 30 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H30C31.933 0.5 33.5 2.067 33.5 4V20C33.5 21.933 31.933 23.5 30 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z",
    stroke: "#E4E4E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4342 4.8007C22.4865 4.73771 25.7789 8.01542 25.8424 12.0497V12.1132C25.7158 16.0846 22.4866 19.2997 18.4342 19.2997H15.8385C11.9128 19.2367 8.74678 16.0216 8.74674 12.1132C8.6201 8.20475 11.6597 4.92678 15.5221 4.8007H18.4342ZM16.028 6.06144C12.7357 6.06164 10.0136 8.77197 10.0133 12.0497C10.0134 15.3276 12.7356 18.0388 16.028 18.039C19.3205 18.0389 22.0436 15.3277 22.0436 12.0497C22.0434 8.77188 19.3204 6.06149 16.028 6.06144ZM15.0788 16.0849C12.8628 15.5176 11.5326 13.2481 12.1022 11.0419C12.4821 9.592 13.6224 8.45726 15.0788 8.07902V16.0849ZM16.9782 8.07902C19.1942 8.64641 20.587 10.8522 20.0172 13.0585C19.6373 14.5715 18.4978 15.7066 16.9782 16.0849V8.07902Z",
    fill: "#0079BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/DinersClub.c20073946e4871d5b3cb9007ce46fe11.svg";
export { ForwardRef as ReactComponent };